import React from "react";

/**
 * ปุ่มเลือกรอบแบบรูปภาพ (ภาคปกติ / พยาบาล / กศ.บป. / ป.บัณฑิต)
 *
 * ต้องคง name="robId" และ id=ROB_ID ไว้บน element ที่คลิก
 * เพราะ handleClick ในหน้า Register อ่านค่าจาก attribute ทั้งสองตัวนี้
 *
 * caption = ข้อความใต้ปุ่ม (ไม่ส่ง = ไม่แสดง เช่นรอบที่ฝังวันไว้ในรูปแล้ว)
 */
function RoundImageButton({ round, caption, selectedRobId, onSelect }) {
  const selected = Boolean(round.id) && String(selectedRobId) === String(round.id);
  const state = `${round.open ? "" : " is-disabled"}${selected ? " is-selected" : ""}`;

  const button = (
    <div className={`reg-round${state}`}>
      <img
        src={round.src}
        alt={round.label}
        name="robId"
        id={round.id || undefined}
        onClick={round.open ? onSelect : undefined}
      />
    </div>
  );

  if (!caption) {
    return button;
  }

  return (
    <div className={`reg-round-item${selected ? " is-selected" : ""}`}>
      {button}
      <div className="reg-round__caption">{caption}</div>
    </div>
  );
}

export default RoundImageButton;
